import { Button, Input, ToastMessage } from '@cokitchen/cokitchen-components';
import React, { FC, useState } from 'react';
import { ReactComponent as SmileyIcon } from 'assets/icons/smiley.svg';
import { ReactComponent as OtherIcon } from 'assets/icons/other.svg';
import { ReactComponent as TestingIcon } from 'assets/icons/testing.svg';
import { ReactComponent as TimeIcon } from 'assets/icons/time.svg';
import LocalModal from 'components/base/local-modal';
import LocalTextArea from 'components/base/local-text-area';
import { apiService } from 'services/base.service';
import { useNavigate } from 'react-router';
import { ROUTE_KEYS } from 'utils/constants';
import { toast } from 'react-toastify';
import { handleApiError } from 'utils/functions';
import useOrdersContext from 'contexts/orders.context';

type CancelOrderModalProps = {
  show: boolean;
  onClose: () => void;
  orderCode: string;
};
const reasons = [
  {
    text: 'Change of plans',
    icon: <TestingIcon />
  },
  {
    text: 'Budget constraint',
    icon: <SmileyIcon />
  },
  {
    text: 'Kitchen took too long to accept',
    icon: <TimeIcon />
  },
  {
    text: 'Unexpected event, unable to receive order',
    icon: <TimeIcon />
  },
  {
    text: 'Other',
    icon: <OtherIcon />
  }
];
const CancelOrderModal: FC<CancelOrderModalProps> = ({ show, onClose, orderCode }) => {
  const navigate = useNavigate();
  const { handleReset } = useOrdersContext();
  const handleClose = () => {
    onClose();
  };
  const [selectedReason, setSelectedReason] = useState('');
  const [commentNote, setCommentNote] = useState('');
  const [loading, setLoading] = useState(false);

  const cancelOrder = async () => {
    setLoading(true);
    try {
      const res = await apiService.post(`order/cancel`, {
        baseURL: process.env.REACT_APP_ORDER_API_URL,
        data: {
          order_code: orderCode,
          cancelled_note: selectedReason === 'Other' ? commentNote : selectedReason
        }
      });
      if (res) {
        handleReset();
        handleClose();
        navigate(`/${ROUTE_KEYS.ORDERS}`);
        toast(<ToastMessage type='success' message={'Order Cancelled '} />);
      }
    } catch (err) {
      handleApiError(err, 'Error Canceling your Order');
    }
  };
  const isConfirmButtonDisabled = !selectedReason || (selectedReason === 'Other' && !commentNote);
  return (
    <LocalModal
      isOpen={show}
      onRequestClose={handleClose}
      title='We are sorry to see you go! '
      contentClassName=' sm:!max-w-[400px]'>
      <div>
        <div>
          <div className='text-gray-3 ml-4 mb-4  whitespace-nowrap'>
            Kindly tell us your reason for cancelling....
          </div>
          {reasons.map((reason, index) => (
            <div className='pl-2 pr-2 h-[40px] mt-3 flex items-center gap-4' key={index}>
              {reason.icon}
              <label htmlFor='' className='text-xs'>
                {reason.text}
              </label>
              <Input
                className='ml-auto'
                type='radio'
                onChange={() => setSelectedReason(reason.text)}
                checkColor='red'
                checked={selectedReason === reason.text}
              />
            </div>
          ))}

          {selectedReason === 'Other' && (
            <div>
              <div className='text-sm font-medium flex gap-1 mt-5 mb-2'>
                <p className='text-[#2E3031]'>Tell us the other reasons</p>
              </div>
              <LocalTextArea
                placeholder='Other reasons...'
                className='text-sm bg-[#FAFAFA] border-x-0 border-t-0 rounded-none h-[100px]'
                value={commentNote}
                onChange={(e) => setCommentNote(e.target.value)}
              />
            </div>
          )}
        </div>
        {/* <div className='text-sm font-medium flex gap-1 mt-5 mb-2'>
          <p className='text-[#2E3031]'>Leave a comment</p>
        </div>
        <LocalTextArea
          placeholder='e.g I was not hungry'
          className='text-sm bg-[#FAFAFA] border-x-0 border-t-0 rounded-none h-[135px]'
          value={commentNote}
          onChange={(e) => setCommentNote(e.target.value)}
        /> */}
      </div>
      <div className='mt-5 flex justify-end'>
        <Button
          color='gray'
          variant='block'
          className='mr-4 w-[139px] h-[41px]'
          onClick={handleClose}>
          Go Back
        </Button>
        <Button
          color='primary'
          variant='block'
          className='w-[139px] h-[41px]'
          loading={loading}
          onClick={cancelOrder}
          disabled={isConfirmButtonDisabled}>
          Cancel Order
        </Button>
      </div>
    </LocalModal>
  );
};

export default CancelOrderModal;
